import { call, put } from 'redux-saga/effects';
import { AxiosError, AxiosResponse } from 'axios';

// Response / Request
import { Result } from '@models/common/resultResponse';
import { KeyValue } from '@/main/models/common';

// Redux
import { GetDomainBySystemApplication, saveDomainBySystemApplication } from './index';

// Api's
import { templateEmailNotificationApi } from '../../api';
import { errorBoundaryReduxSaga, renderErrorReduxSaga } from '@/main/services/utils';

export function* getDomainBySystemApplicationSaga(action: GetDomainBySystemApplication) {
  try {
    const response: AxiosResponse<Result<KeyValue[]>> = yield call(
      templateEmailNotificationApi.getDomainBySystemApplication,
      action.payload.request
    );
    if (response.data.result) {
      yield put(saveDomainBySystemApplication(response.data.result, false, null));
    }
  } catch (exception) {
    if (exception instanceof AxiosError) {
      const resultError = errorBoundaryReduxSaga(exception);
      renderErrorReduxSaga(resultError);

      yield put(saveDomainBySystemApplication(null, true, resultError.messagesDataError));
    }
  }
}
